import React,{useEffect,useState} from "react";
import { Row, Col, Card, CardBody,Button } from "reactstrap";
import Dropzone from "react-dropzone";
import {httpGet,httpUpload} from "../../common/petitions"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './model.json'
import "./tables.scss";
import "./Puestos.scss";
import DataLoader from "../../components/tableData";
import { useNavigate } from 'react-router-dom'
const rubroDepreciaciones = () => {
  const [uploadResult, setUploadResult] = useState(null);
  const [data, setData] = useState({});
  const [data2, setData2] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const nameTemplateExcel = 'PRESUPUESTOMAQ_RENTAS'
  const downloadTemplate = async () => {
    try {
      const response = await fetch(`/templates_xls/${nameTemplateExcel}.xlsx`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${nameTemplateExcel}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const rowsData = await httpGet(`/rubros/20242025/rentasfijas`,navigate);
      const jsonData = { "columns": Models.headers, "rows": rowsData };
      setData(jsonData);
      const fijas = await httpGet(`/rubros/20242025/rentasvariables`,navigate);
      const jsonfijas = { "columns": Models.headers, "rows": fijas };
      setData2(jsonfijas);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false)
  };
  const uploadFile = async (file) => {
    setIsUploading(true);
    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("rubro", 'rentas');
    try {
      const result = await httpUpload(`/rubros/import`,formdata,navigate);
      setUploadResult(result);
      fetchData();
    } catch (error) {
      console.error("Error uploading file:", error);
    }finally {
      setIsUploading(false);
    }
  };


  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };


  
  useEffect(() => {
    fetchData();
  }, []); 
  
  
  document.title = "Rubros - Ingreso de rentas fijas y variables - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Rubros" title="Ingreso de rentas fijas y variables"  />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                    <Dropzone onDrop={handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone-container">
                          <div className="btn btn-success dropzone  me-5 " {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span>Subir archivo</span>
                          </div>
                          {uploadResult && (
                            <div className="upload-check">
                              <i className="bx bx-check-circle"></i>
                            </div>
                          )}
                        </div>
                      )}
                    </Dropzone>

                <Button color="light" className="mi-5" onClick={downloadTemplate}>
                  <i className="bx bx-download me-1"></i> Descargar Plantilla (.xlsx)
                </Button>
                <h1>
                  RENTAS FIJAS
                </h1>
                <DataLoader isLoading={isLoading} data={data}  rubro={"rentasfijas"} reload={fetchData}/>
                <h1>
                  RENTAS VARIABLES
                </h1>
                <DataLoader isLoading={isLoading} data={data2}  rubro={"rentasvariables"}reload={fetchData}/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default rubroDepreciaciones;
